// Vue, Vuex, Router and Axios
import Vue from "vue"
import Vuex from 'vuex'
import VueRouter from "vue-router"
import axios from 'axios'
import moment from 'moment';
import momentTz from 'moment-timezone';
import VueNumeric from 'vue-numeric'
import VuePassword from 'vue-password'



window.CryptoJS = require("crypto-js");
// Moment JS with Spanish Translation
require('moment/locale/es'); // Moment Spanish Translation
moment.suppressDeprecationWarnings = false;

import 'animate.css'
require('normalize.css');
require('../css/app.css');
require('../css/leaflet.css');


//OKI
// Element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import locale from 'element-ui/lib/locale/lang/es';
import VueProgressBar from 'vue-progressbar';


Vue.use(VueProgressBar, {
    color: '#2cbb44',
    failedColor: '#fbbd08',
    height: '10px'
});

//---->

import {
	LMap,
	LTileLayer,
	LMarker,
	LTooltip,
	LPopup,
} from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet'





Vue.component('l-map', LMap);
Vue.component('l-titlelayer', LTileLayer);
Vue.component('l-marker', LMarker);

delete Icon.Default.prototype._getIconUrl;

/*
Icon.Default.mergeOptions({
	iconRetinaUrl: require('../img/marker/marker-icon2-2x-1.png'),
	iconUrl: require('../img/marker/marker-icon-1.png'),
	shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
*/
Icon.Default.mergeOptions({
	iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
	iconUrl: require('leaflet/dist/images/marker-icon.png'),
	shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

//--->

require('./utils/filters.js');
require('./directives/index.js');
// Font Awesome Icons
require('@fortawesome/fontawesome-free/css/all.min.css');

// Idle
import IdleVue from 'idle-vue'
const eventsHub = new Vue();
Vue.use( Vuex );
Vue.use( VueRouter );
Vue.use( ElementUI, { locale } );
Vue.use( require('vue-moment'), { moment, momentTz });
Vue.use(VueNumeric);
Vue.use(VuePassword);





Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    idleTime: 15/*Minutes*/ * 60/*Seconds*/ * 1000/*Miliseconds*/
});
window.$ = window.jQuery = require('jquery');
window.Vue = Vue;
window.axios = axios;
window._ = require('lodash');
window.moment = moment;
window.google = '6LfM2eIUAAAAAK15kiYgOwaXHiNzbnobW_AcIO8y';
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json',
	'Accept-C': window.acceptC
};

if (window.sessionStorage.getItem('sre_young_token')) {
    window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.sessionStorage.getItem('sre_young_token');
}
